module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAUCAYAAACEYr13AAABO0lEQVQ4jZ3UvyvFURjH8de9bn6EQRlIGEX+ALtiIMkkk1JG2c3+AkZkUBgsZLcxySIMwuBHMfg16JYY7vnW1+1+j8tnep7zPJ/3eTrnfL+5w+NrGWpHT4gvcF+pqZBhnsQCOkJ+i0VsVQOYwUrZWgs20YjVdCFf1tiF5YypYAmdMUAf6iOABvTHAC0Rc6L2GOC5CsBDDHCBYsRcxHkMcIWdCGAn9GQCvpTu+7WC+SXUvmIAOMUEnlJrdxgNtR+qBIAjXKbyM5xUaix/ieMYwYCf9z2IwwDew25SyIWPqRVrYcxcxlSJPrGNeTwWUIcNDP9iTFSDqbDpWB5zfzCnNYS5PGb/YU40m5dxulXqpIBprCudfg96Q7EetSEu4iPEZ0pPfh8HudQvrRZNaA55N9pC/ICbEL/hPUB9A8gRP0OdZ7gMAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/username.png
// module id = qROW
// module chunks = 1